import {FilterOptions, Interval} from "../types";
import {trimestersMonths} from "../DocumentsCostants";

export const createDateIntervals = (options: FilterOptions): Interval[] => {
    const intervals: Interval[] = [];

    if (options.filterType === "Personalizzato" && options.startDate && options.endDate) {
        intervals.push({ startDate: options.startDate, endDate: options.endDate });
    } else if (options.specificYear) {
        const year = options.specificYear;

        if (options.filterType === "Mese" && options.selectedMonths) {
            options.selectedMonths.forEach((month) => {
                const start = new Date(year, month, 1);
                const end = new Date(year, month + 1, 0, 23, 59, 59);
                if (isValidDate(start) && isValidDate(end)) {
                    intervals.push({
                        startDate: start.toISOString(),
                        endDate: end.toISOString(),
                    });
                }
            });
        } else if (
            options.filterType === "Trimestre" &&
            options.selectedTrimesters
        ) {
            options.selectedTrimesters.forEach((trimesterIndex) => {
                const { startMonth, endMonth } = trimestersMonths[trimesterIndex];
                const start = new Date(year, startMonth, 1);
                const end = new Date(year, endMonth + 1, 0, 23, 59, 59);
                if (isValidDate(start) && isValidDate(end)) {
                    intervals.push({
                        startDate: start.toISOString(),
                        endDate: end.toISOString(),
                    });
                }
            });
        }
    }

    return intervals;
};

export const isValidDate = (date: Date) => {
    return date instanceof Date && !isNaN(date.getTime());
};

export const getStartEndYear = (year: number | string) => {
    const startDate = new Date(Number(year), 1, 1).toISOString()
    const endDate = new Date(Number(year), 11, 31, 23, 59, 59, 999).toISOString()

    return {startDate, endDate}
}
